/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Terms_Section_4_ClosingInputs */

const en_terms_section_4_closing = /** @type {(inputs: Terms_Section_4_ClosingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The site carries an AI assistant. What it says is informational: it is not professional advice, a commitment, or a binding offer.`)
};

const lv_terms_section_4_closing = /** @type {(inputs: Terms_Section_4_ClosingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tīmekļvietnē darbojas AI asistents. Tā teiktais ir informatīvs: tas nav profesionāls padoms, saistība vai saistošs piedāvājums.`)
};

/**
* | output |
* | --- |
* | "The site carries an AI assistant. What it says is informational: it is not professional advice, a commitment, or a binding offer." |
*
* @param {Terms_Section_4_ClosingInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const terms_section_4_closing = /** @type {((inputs?: Terms_Section_4_ClosingInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Terms_Section_4_ClosingInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_terms_section_4_closing(inputs)
	return en_terms_section_4_closing(inputs)
});